import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import { BasicModal, DefaultButton, PageContentPreloader } from 'common/components';
import RadialChart from 'common/dashboards/_components/RadialChart';
import TargetForm from 'common/dashboards/_components/TargetForm';

import { hasMetricData } from 'common/dashboards/metrics';
import { withTheme } from 'common/styling/theme';
import { staticStyles, getDynamicStyles } from './style';

const FulfillmentOfPlans = ({
  theme,
  target,
  targetIsLoaded,
  partnerId,
  viewMode,
  intl,
  currentMonthName,
  currentMonthFunnel,
  lastMonthFunnel,
  sampleType,
  isClientInterface,
}) => {
  const { users: registeredTarget = 100, realUsers: realUsersTarget = 50, depositedUsers: ftdTarget = 10 } = target;
  const {
    joined_users: currentUsers = 0,
    users_created_real_account: currentRealUsers = 0,
    deposited_users: currentFtd = 0,
  } = currentMonthFunnel || {};
  const {
    joined_users: lastMonthUsers = 0,
    users_created_real_account: lastMonthRealUsers = 0,
    deposited_users: lastMonthFtd = 0,
  } = lastMonthFunnel || {};
  const registeredPercent = (currentUsers / registeredTarget) * 100;
  const realUsersPercent = (currentRealUsers / realUsersTarget) * 100;
  const depositedPercent = (currentFtd / ftdTarget) * 100;

  const dynamicStyles = Object.keys(theme).length ? getDynamicStyles(theme) : ` `;

  const [isModalOpen, setIsModalOpen] = useState(false);

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  return (
    <>
      <div className="FulfillmentOfPlans">
        <div className="FulfillmentOfPlans__top-line">
          <FormattedMessage id="boFulfillmentOfPlans" values={{ month: currentMonthName }}>
            {txt => <h3>{txt}</h3>}
          </FormattedMessage>
          <DefaultButton
            textId="justEditTarget"
            type="button"
            disabled={!targetIsLoaded}
            onClick={openModal}
            filled
            plus
          />
        </div>
        <div className="FulfillmentOfPlans__left-inner">
          <div className="ChartInner">
            <PageContentPreloader
              ready={
                targetIsLoaded &&
                hasMetricData(currentMonthFunnel, 'joined_users') &&
                hasMetricData(lastMonthFunnel, 'joined_users')
              }
              type="bigLine"
              noPadding>
              <RadialChart
                percent={registeredPercent}
                color="#43B6E8"
                gradientEndColor="#33EEC7"
                captionId={intl.formatMessage({ id: 'boRegistered' })}
                amountNow={currentUsers}
                target={registeredTarget}
                amountLastMonth={lastMonthUsers}
              />
            </PageContentPreloader>
          </div>
          <div className="ChartInner">
            <PageContentPreloader
              ready={
                targetIsLoaded &&
                hasMetricData(currentMonthFunnel, 'users_created_real_account') &&
                hasMetricData(lastMonthFunnel, 'users_created_real_account')
              }
              type="bigLine"
              noPadding>
              <RadialChart
                percent={realUsersPercent}
                color="#6ec448"
                gradientEndColor="#a0d54f"
                captionId={intl.formatMessage({ id: 'boOpenedLiveAccount' })}
                amountNow={currentRealUsers}
                target={realUsersTarget}
                amountLastMonth={lastMonthRealUsers}
              />
            </PageContentPreloader>
          </div>
        </div>
        <div className="FulfillmentOfPlans__right-inner">
          <div className="ChartInner">
            <PageContentPreloader
              ready={
                targetIsLoaded &&
                hasMetricData(currentMonthFunnel, 'deposited_users') &&
                hasMetricData(lastMonthFunnel, 'deposited_users')
              }
              type="bigLine"
              noPadding>
              <RadialChart
                percent={depositedPercent}
                color="#39DBD3"
                gradientEndColor="#39DBD3"
                captionId={intl.formatMessage({ id: 'boFTD' })}
                amountNow={currentFtd}
                target={ftdTarget}
                amountLastMonth={lastMonthFtd}
              />
            </PageContentPreloader>
          </div>
        </div>

        <style jsx>{staticStyles}</style>
        <style jsx>{dynamicStyles}</style>
      </div>
      <BasicModal captionId="justTargets" isOpen={isModalOpen} onRequestClose={closeModal}>
        <TargetForm
          initialValues={{
            users: registeredTarget,
            realUsers: realUsersTarget,
            depositedUsers: ftdTarget,
          }}
          lastMonthUsers={lastMonthUsers}
          lastMonthRealUsers={lastMonthRealUsers}
          lastMonthFtd={lastMonthFtd}
          closeModal={closeModal}
          viewMode={viewMode}
          partnerId={partnerId}
          sampleType={sampleType}
          isClientInterface={isClientInterface}
        />
      </BasicModal>
    </>
  );
};

FulfillmentOfPlans.propTypes = {
  intl: PropTypes.object.isRequired,
  partnerId: PropTypes.number.isRequired,
  theme: PropTypes.object,
  currentMonthFunnel: PropTypes.object,
  lastMonthFunnel: PropTypes.object,
  target: PropTypes.object,
  targetIsLoaded: PropTypes.bool,
  viewMode: PropTypes.string,
  currentMonthName: PropTypes.string.isRequired,
  sampleType: PropTypes.string.isRequired,
  isClientInterface: PropTypes.bool,
};

FulfillmentOfPlans.defaultProps = {
  theme: {},
  currentMonthFunnel: {},
  lastMonthFunnel: {},
  target: {},
  targetIsLoaded: true,
  viewMode: '',
  isClientInterface: false,
};

export default compose(injectIntl, withTheme())(FulfillmentOfPlans);
export { FulfillmentOfPlans };
